// extracted by mini-css-extract-plugin
module.exports = {"container":"OhSnap_container__-cPeM","header":"OhSnap_header__3lSzj"};